import * as Sentry from "@sentry/react";

export const startSentry = () => {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN_WEB,
    environment: import.meta.env.VITE_NODE_ENV,
    release: import.meta.env.VITE_GIT_COMMIT
  });
};
